(() => {
  'use strict';

  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  const revealSelector = [
    'main .shopify-section',
    'main .card-wrapper',
    'main .collection-card-wrapper',
    'main .article-card-wrapper',
    'main .multicolumn-card',
    'main .wbtestisub .testimain'
  ].join(',');

  let revealObserver;

  function revealAll(root = document) {
    root.querySelectorAll('.sign-reveal').forEach((element) => {
      element.classList.add('sign-reveal--visible');
    });
  }

  function initializeReveals(root = document) {
    const elements = Array.from(root.querySelectorAll(revealSelector)).filter(
      (element) => !element.classList.contains('sign-reveal')
    );

    if (!elements.length) return;

    elements.forEach((element, index) => {
      element.classList.add('sign-reveal');
      element.style.setProperty('--sign-reveal-delay', `${Math.min(index % 4, 3) * 55}ms`);
    });

    if (motionQuery.matches || !('IntersectionObserver' in window)) {
      revealAll(root);
      return;
    }

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('sign-reveal--visible');
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
      );
    }

    elements.forEach((element) => revealObserver.observe(element));
  }

  function handleMotionPreference(event) {
    if (event.matches) revealAll();
  }

  document.documentElement.classList.add('sign-motion-ready');

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeReveals(), { once: true });
  } else {
    initializeReveals();
  }

  if (typeof motionQuery.addEventListener === 'function') {
    motionQuery.addEventListener('change', handleMotionPreference);
  }

  document.addEventListener('shopify:section:load', (event) => initializeReveals(event.target));
})();
